import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { BillingInvoiceAssociateFilter } from '../../model/billing/index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceAssociateService {

  constructor( private dataService: DataService ) {
  }

  private readonly billingInvoiceAssociateEndPoint: string =
    '/billingInvoiceAssociate/getBillingInvoiceAssociateFilters/';

    getBillingInvoiceAssociateFilters( number: number ): Observable<BillingInvoiceAssociateFilter[]> {

      if (!number) {
        return new Observable<BillingInvoiceAssociateFilter[]>();
      }

      const params = { number };
      return this.dataService.get<BillingInvoiceAssociateFilter[]>
        (this.billingInvoiceAssociateEndPoint, params);

  }
}
